<template>
    <SearchDialog
        :context="context"
        :searchcontext="'WorksFor' + context"
        subcontext="Works"
        :addcontext="'WorksTo' + context"
        addButtonLabel="lang_LABEL_TRACKS_CONNECT_WORK_DIALOG_TITLE"
        dialogTitle="lang_LABEL_TRACKS_CONNECT_WORK_DIALOG_TITLE"
        :withoutCheckboxesList="true"
        :alvqaContext="alvqa"
    >
        <template v-slot:itemTitle="{ item }">
            {{ item.title }}
        </template>
        <template v-slot:itemSubtitle="{ item }">
            {{ $t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID')  }}: {{ item.gemaNumber !== '' && item.gemaNumber !== null ? item.gemaNumber :  $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM')}} |
            {{ $t('lang_GENERIC_CAPTION_ALVID') }}: {{ item.alvId }}
        </template>  
    </SearchDialog>
</template>

<script>
import SearchDialog from '@/components/_dialogs/SearchDialog'

export default {
    name: "ConnectWorkToTrackDialog",
    data() {
        return {
            context: "Tracks",
            alvqa: "label-tracks-edit-form"
        }
    },
    components: {
        SearchDialog
    }
}
</script>